const config = {
  locale: 'fr',
  locales: [
    'fr',
    'en',
    'es',
    'it',
    'de'
  ],
  currencyIsoCode: 'EUR'
};

switch (process.env.NODE_ENV) {
  case 'production':
    config.palyanceUrl = 'https://app-front.palyance.info';
    config.palyanceApiUrl = 'https://api.palyance.info';
    config.orionUrl = 'https://2br2tm0jng.execute-api.eu-central-1.amazonaws.com/prod';
    config.newOrionUrl = 'https://orion.pubfac.com';
    config.curiosityUrl = 'https://curiosity.pubfac.io';
    config.snsfUrl = 'https://snsf.pubfac.io';
    config.pgsfUrl = 'https://hsp6mn16j0.execute-api.eu-central-1.amazonaws.com/prod';
    config.updateSalesforceApiUrl = 'https://6d7gt0p8h8.execute-api.eu-central-1.amazonaws.com/prod';
    config.globalConfigUrl = 'https://cdn-common.pubfac.io/vanguard/global-config.json';
    config.loggerUrl = 'https://j8bml3ygp2.execute-api.eu-central-1.amazonaws.com/prod';
    config.sentryDsn = 'https://2473ea621e1147dc8c2d9f9e4de6e605@sentry.io/1479290';
    break;
  case 'qa':
    config.palyanceUrl = 'https://app-front.qa-palyance.info';
    config.palyanceApiUrl = 'https://api.qa-palyance.info';
    config.orionUrl = 'https://uq63c4n3y0.execute-api.eu-central-1.amazonaws.com/qa';
    config.newOrionUrl = 'https://orion.qa-pubfac.com';
    config.curiosityUrl = 'https://curiosityv2.qa-pubfac.io';
    config.snsfUrl = 'https://3tm4mfzli6.execute-api.eu-central-1.amazonaws.com/qa';
    config.pgsfUrl = 'https://9p0k3ng4v5.execute-api.eu-central-1.amazonaws.com/qa';
    config.updateSalesforceApiUrl = 'https://1t95f95192.execute-api.eu-central-1.amazonaws.com/qa';
    config.globalConfigUrl = 'https://qa-cdn-common.qa-pubfac.io/vanguard/global-config.json';
    config.loggerUrl = 'https://60enjbbucf.execute-api.eu-central-1.amazonaws.com/dev';
    config.sentryDsn = 'https://ec7cc3c09bf4403da6612f091e25c854@o998739.ingest.sentry.io/5957718';
    break;
  case 'integration':
    config.palyanceUrl = 'https://palyancev2-app-front.int-pubfac.io';
    config.palyanceApiUrl = 'https://palyancev2-api.int-pubfac.io';
    config.orionUrl = 'https://g65q7x3mkg.execute-api.eu-central-1.amazonaws.com/preprod';
    config.newOrionUrl = 'https://orion.qa-pubfac.com';
    config.curiosityUrl = 'https://curiosityv2.int-pubfac.io';
    config.snsfUrl = 'https://tr4261qlh9.execute-api.eu-central-1.amazonaws.com/preprod';
    config.pgsfUrl = 'https://45qm66alub.execute-api.eu-central-1.amazonaws.com/preprod';
    config.updateSalesforceApiUrl = 'https://towiw2a8tb.execute-api.eu-central-1.amazonaws.com/preprod';
    config.globalConfigUrl = 'https://cdn-common.int-pubfac.io/vanguard/global-config.json';
    config.loggerUrl = 'https://60enjbbucf.execute-api.eu-central-1.amazonaws.com/dev';
    config.sentryDsn = 'https://ec7cc3c09bf4403da6612f091e25c854@o998739.ingest.sentry.io/5957718';
    break;
  default:
    config.palyanceUrl = 'https://palyancev2-app-front.dev-pubfac.io';
    config.palyanceApiUrl = 'https://palyance-front.dev-pubfac.io';
    config.orionUrl = 'https://s7sjgepkli.execute-api.eu-central-1.amazonaws.com/preprod';
    config.newOrionUrl = 'https://orion.dev-pubfac.com';
    config.curiosityUrl = 'https://curiosityv2.dev-pubfac.io';
    config.snsfUrl = 'https://mg1yeh70i6.execute-api.eu-central-1.amazonaws.com/preprod';
    config.pgsfUrl = 'https://xlayh0rw9f.execute-api.eu-central-1.amazonaws.com/preprod';
    config.updateSalesforceApiUrl = 'https://y6o5fj8r6h.execute-api.eu-central-1.amazonaws.com/preprod';
    config.globalConfigUrl = 'https://cdn-common.dev-pubfac.io/vanguard/global-config.json';
    config.loggerUrl = 'https://60enjbbucf.execute-api.eu-central-1.amazonaws.com/dev';
    config.sentryDsn = 'https://ec7cc3c09bf4403da6612f091e25c854@o998739.ingest.sentry.io/5957718';
}

export default config;



// WEBPACK FOOTER //
// ./config/vanguard.js